import { LocalizedValueInput } from "gql/graphql";

export function getInitialLocalizedValueInput(): LocalizedValueInput {
  return {
    langValueEn: null,
    langValueKz: null,
    langValueRu: null,
    langValueUz: null,
  };
}
